var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { show: _vm.$apollo.loading } },
    [
      !_vm.$apollo.loading && _vm.showSettingsPage
        ? _c(
            "b-tabs",
            {
              attrs: {
                vertical: "",
                "nav-wrapper-class": "col-3",
                "nav-class": "mt-5"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "tabs-start",
                    fn: function() {
                      return [
                        _c("h3", [_vm._v(_vm._s(_vm.$t("settings.settings")))])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1879671306
              ),
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _vm.$hasPrivileges(
                _vm.$privileges("CAN_EDIT_ROOT_SETTINGS"),
                _vm.userObject.isSysAdmin,
                _vm.currentItemObject.privilegesForItem
              ) && _vm.isRootFolder
                ? _c(
                    "b-tab",
                    {
                      on: {
                        click: function($event) {
                          return _vm.setUrl("")
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("settings.folder.group.tabName")
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2271020915
                      )
                    },
                    [
                      _c("folder-settings-domain", {
                        staticClass: "mt-5",
                        attrs: {
                          "group-id": _vm.groupId,
                          "group-name": _vm.groupName,
                          "group-domain": _vm.groupDomain,
                          "group-slug": _vm.groupSlug,
                          "is-sys-admin": _vm.userObject.isSysAdmin,
                          "pirsch-code": _vm.pirschCode
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isRootFolder &&
              _vm.$hasPrivileges(
                _vm.$privileges("CAN_EDIT_SETTINGS_PUBLICATION"),
                _vm.userObject.isSysAdmin,
                _vm.currentItemObject.privilegesForItem
              )
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(_vm.$t("settings.folder.tabName"))
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2116363298
                      )
                    },
                    [
                      _c("folder-settings-publications", {
                        staticClass: "mt-5",
                        attrs: {
                          "sibling-slugs": _vm.allChildSlugsOfParentFolder,
                          "folders-data": _vm.folderData
                        },
                        on: {
                          updateFolderSettings:
                            _vm.updateFolderPublicationSettings
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$hasPrivileges(
                _vm.$privileges("CAN_EDIT_SETTINGS_CI"),
                _vm.userObject.isSysAdmin,
                _vm.currentItemObject.privilegesForItem
              )
                ? _c(
                    "b-tab",
                    {
                      ref: _vm.$t("settings.folder.corporateIdentity.hash"),
                      on: {
                        click: function($event) {
                          _vm.setUrl(
                            _vm.$t("settings.folder.corporateIdentity.hash")
                          )
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "settings.folder.corporateIdentity.tabName"
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3263614937
                      )
                    },
                    [
                      !_vm.$apollo.loading
                        ? _c("folder-settings-corporate-identity", {
                            staticClass: "mt-5",
                            attrs: {
                              "custom-group-fonts": _vm.customGroupFonts,
                              "is-super-admin": _vm.userObject.isSysAdmin,
                              "corporate-identity-data": _vm.corporateIdentity
                            },
                            on: {
                              "update-ci-settings": _vm.updateCISettings,
                              "override-children": _vm.overrideChildrenWithCI,
                              "override-all-children": _vm.overrideAllCIChildren
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$hasPrivileges(
                _vm.$privileges("CAN_EDIT_SETTINGS_PLUGINS"),
                _vm.userObject.isSysAdmin,
                _vm.currentItemObject.privilegesForItem
              )
                ? _c(
                    "b-tab",
                    {
                      ref: _vm.$t("settings.plugins.hash"),
                      on: {
                        click: function($event) {
                          _vm.setUrl(_vm.$t("settings.plugins.hash"))
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(_vm.$t("settings.plugins.tabName"))
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        464170190
                      )
                    },
                    [
                      _c("plugin-list", {
                        key: _vm.componentKey,
                        staticClass: "mt-5",
                        attrs: {
                          "folder-id": _vm.currentItemObject.id,
                          "is-sys-admin": _vm.userObject.isSysAdmin,
                          privileges: _vm.currentItemObject.privilegesForItem,
                          childPageSlugs: _vm.allChildPageSlugsOfCurrentFolder
                        },
                        on: {
                          "update-plugin-settings": _vm.updatePluginSettings,
                          "override-all-children":
                            _vm.overrideAllPluginChildren,
                          "override-children": _vm.overrideChildrenWithPlugin
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$hasPrivileges(
                _vm.$privileges("CAN_EDIT_CUSTOM_CSS"),
                _vm.userObject.isSysAdmin,
                _vm.currentItemObject.privilegesForItem
              )
                ? _c(
                    "b-tab",
                    {
                      ref: _vm.$t("settings.customCss.hash"),
                      attrs: { lazy: "" },
                      on: {
                        click: function($event) {
                          _vm.setUrl(_vm.$t("settings.customCss.hash"))
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [_vm._v("Custom CSS")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        781904493
                      )
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-4 mt-5" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: { cols: "12", "offset-sm": "1", sm: "10" }
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("settings.customCss.tabTitle")
                                    ) +
                                    " "
                                )
                              ]),
                              _c("hr"),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("settings.customCss.tabDesc")
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "mb-4 pb-4" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: { cols: "12", "offset-sm": "1", sm: "10" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.customCss.customCssLabel"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "b-col",
                            {
                              attrs: { cols: "12", "offset-sm": "1", sm: "10" }
                            },
                            [
                              _c("custom-css-editor", {
                                attrs: { cssCode: _vm.customCss },
                                on: { "update-cssCode": _vm.updateCustomCss }
                              }),
                              _c("b-form-text", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("settings.customCss.customCssDesc")
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                {
                  ref: _vm.$t("settings.analytics.hash"),
                  attrs: { lazy: "" },
                  on: {
                    click: function($event) {
                      _vm.setUrl(_vm.$t("settings.analytics.hash"))
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settings.analytics.usefathomTabName")
                              )
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1200606680
                  )
                },
                [
                  _vm.slugPathFromUrl &&
                  _vm.groupDomain &&
                  _vm.currentItemObject
                    ? _c("usefathom-analytics-dashboard", {
                        attrs: {
                          "group-domain": _vm.groupDomain,
                          "slug-path-from-url": _vm.slugPathFromUrl,
                          "item-id": _vm.currentItemObject.id,
                          "item-type": "folder",
                          showReadersInTable: _vm.showReadersInTable,
                          isSysAdmin: _vm.userObject.isSysAdmin
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.userObject.isSysAdmin
                ? _c(
                    "b-tab",
                    {
                      ref: "stats",
                      attrs: { lazy: "" },
                      on: {
                        click: function($event) {
                          return _vm.setUrl("stats")
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(_vm.$t("settings.analytics.tabName"))
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3916627714
                      )
                    },
                    [
                      _vm.slugPathFromUrl &&
                      _vm.groupSlug &&
                      _vm.groupDomain &&
                      _vm.currentItemObject &&
                      _vm.pirschCode
                        ? _c("pirsch-analytics-dashboard", {
                            attrs: {
                              "group-domain": _vm.groupDomain,
                              "group-slug": _vm.groupSlug,
                              "slug-path-from-url": _vm.slugPathFromUrl,
                              "item-id": _vm.currentItemObject.id,
                              "item-type": _vm.currentItemObject.type,
                              "pirsch-code": _vm.pirschCode
                            }
                          })
                        : !_vm.pirschCode
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-row",
                                { staticClass: "row mb-4 mt-5" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        "offset-sm": "1",
                                        sm: "10"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "settings.analytics.noPirschCode"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("modal-leave-page", { ref: "leaveModalWindow" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }